import fetchAPI from '../utils/fetchAPI';

const getPosts = async (settings, args, page = 1) => {
	let url = `${settings.apiBase}/get-posts?posts_per_page=${settings.postsPerPage}&paged=${page}`;

	if (args.searchQuery) {
		url += `&s=${args.searchQuery}`;
	}

	url += args.selectedTax?.postType
		? `&post_type=${args.selectedTax.postType}`
		: `&post_type=any`;

	return await fetchAPI(url);
};

export default getPosts;
